import React, { useContext } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Icon, Segment, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../../..'
import { HERD_GROUP_ERROR_CLASS } from '../../../constants'

interface Props {
  herdIndex: number
}

const ManureType:React.FC<Props> = ({ herdIndex }) => {
  const { t } = useTranslation()
  const { control, getValues } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const { fields: manureFields, append, remove } = useFieldArray({
    control,
    name: `herdGroups[${herdIndex}].manureStorageTypes`
  })

  const manureTypes = options?.manureStorageTypes?.map(manureStorage => ({ value: manureStorage.id, text: manureStorage.label })) || []

  return (
    <>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t('Type')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Percentage')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {manureFields.map((field, manureIndex) => (
            <Table.Row key={field.id}>
              <Table.Cell>
                <FormFields.Select
                  search
                  control={control}
                  name={`herdGroups[${herdIndex}].manureStorageTypes[${manureIndex}].id`}
                  options={manureTypes}
                  placeholder={t('Type')}
                  rules={{ required: true }}
                  withoutLabel
                  noErrorMessage
                />
              </Table.Cell>
              <Table.Cell>
                <FormFields.Input
                  control={control}
                  name={`herdGroups[${herdIndex}].manureStorageTypes[${manureIndex}].percent`}
                  placeholder={t('Amount')}
                  rules={{ required: true }}
                  typeInput='controled'
                  allowDecimals
                  decimalScale={2}
                  withoutAsterisk
                  noErrorMessage
                />
              </Table.Cell>
              <Table.Cell textAlign='center'>
                <Icon
                  name='trash'
                  color='red'
                  style={{ cursor: 'pointer', fontSize: '1.2em' }}
                  onClick={() => remove(manureIndex)}
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          type='button'
          style={{ color: 'white' }}
          icon='plus'
          content={t('Add manure management')}
          onClick={() => {
            const id = getValues(`herdGroups[${herdIndex}].id`)
            const element = document.getElementById(`manure-${id}`)
            if (element && element.classList?.contains(HERD_GROUP_ERROR_CLASS)) {
              element.classList.remove(HERD_GROUP_ERROR_CLASS)
            }
            append({
              id: '',
              percent: ''
            })
          } }
      />
      </div>
    </>
  )
}
export default ManureType